const getMensajeError = response => {

    const data = response?.data ?? response;
    const raw = (data?.response_remoto || data?.response || "").trim();

    if (!raw) return "No se encontró detalle de error.";

    // JSON
    if (raw.startsWith("{") || raw.startsWith("[")) {
        try {
            const obj = JSON.parse(raw);

            if (obj.Message) return obj.Message;
            if (obj.message) return obj.message;
            if (obj.error_description) return obj.error_description;
            if (obj.error) return obj.error;

        } catch (_) { }
    }

    // XML SOAP
    if (raw.startsWith("<")) {
        try {
            const xml = new DOMParser().parseFromString(raw, "text/xml");

            if (xml.querySelector("parsererror"))
                return raw;

            const get = tag => {
                const node = [...xml.getElementsByTagName("*")].find(n => n.localName === tag);
                return node?.textContent?.trim() || "";
            };

            const errorMessage = get("ErrorMessage");
            const errorDesc = get("ErrorDesc");

            if (errorMessage && errorDesc)
                return `${errorMessage}\n${errorDesc}`;

            return errorMessage || errorDesc || raw;

        } catch (_) { }
    }


    return raw;
};

export default getMensajeError;